<template>
  <v-layout row wrap py-3>
    <v-flex xs12 md12>
      <v-layout row wrap>
        <v-flex xs12 md12 pa-1 v-for="(r, i) in resource.data" :key="'resource-' + i">
          <v-card :loading="loading" class="pa-3">
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="r.show = !r.show" color="primary">show data</v-btn>
                <v-btn @click="r.show = !r.show" color="secondary">check ninja lead</v-btn>
                <v-btn @click="getLead(r)" color="success">check crm lead</v-btn>
                <v-btn @click="archive(r)" color="error">archive</v-btn>
              </v-card-actions>
            <v-layout wrap row align-baseline>
              <v-flex xs12 style="height:2px;">
                <v-progress-linear height="2" class="pa-0 ma-0" v-if="loading" :indeterminate="true"></v-progress-linear>
              </v-flex>
              <v-flex xs3 pa-2 v-for="(key, k) in Object.keys(r).filter(x=> !booleans.includes(x) && !data_json.includes(x) && !hidden.includes(x))" :key="'sts-' + k">
                <div style="font-size:9px;font-weight:bold;">{{ key }}</div>
                <div>{{ r[key] }}</div>
              </v-flex>
              <v-flex xs12 pa-0>
                <v-layout wrap row align-baseline pa-0>
                  <v-flex xs3 pa-2 v-for="(key, k) in Object.keys(r).filter(x => booleans.includes(x))" :key="'stsb-' + k">
                    <div style="font-size:9px;font-weight:bold;">{{ key }}</div>
                    <div v-if="r[key] === 1"><v-icon color="success">done</v-icon></div>
                    <div v-else><v-icon color="error">close</v-icon></div>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 pa-0  v-if="r.show">
                Data
              </v-flex>
              <v-flex xs12 pa-0 v-if="r.show" style="background-color: #e8e8e8;" ma-2 pa-2>
                <v-layout wrap row align-baseline pa-0>
                  <v-flex xs3 pa-2 v-for="(key, k) in Object.keys(JSON.parse(r.data)).filter(x => typeof JSON.parse(r.data)[x] !== 'object')" :key="'stsb-' + k">
                    <div style="font-size:9px;font-weight:bold;">{{ key }}</div>
                    <div>{{ JSON.parse(r.data)[key] }}</div>
                  </v-flex>
                  <v-flex xs12 pa-0 v-if="r.show" style="background-color: #d6d6d6;" ma-1 pa-2>
                    {{ r.data }}
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 pa-0  v-if="r.show">
                Ninja Lead
              </v-flex>
              <v-flex xs12 pa-0 v-if="r.show" style="background-color: #e8e8e8;" ma-2 pa-2>
                <v-layout wrap row align-baseline pa-0>
                  <v-flex xs3 pa-2 v-for="(key, k) in Object.keys(r.lead).filter(x => typeof r.lead[x] !== 'object')" :key="'stsb-' + k">
                    <div style="font-size:9px;font-weight:bold;">{{ key }}</div>
                    <div>{{ r.lead[key] }}</div>
                  </v-flex>
                  <v-flex xs12 pa-0 v-if="r.show" style="background-color: #d6d6d6;" ma-1 pa-2>
                    {{ r.lead }}
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 pa-0  v-if="r.show">
                CRM Lead
              </v-flex>
              <v-flex xs12 pa-0 v-if="r.show" style="background-color: #e8e8e8;" ma-2 pa-2>
                <v-layout wrap row align-baseline pa-0>
                  <v-flex xs3 pa-2 v-for="(key, k) in Object.keys(r.crm).filter(x => typeof r.crm[x] !== 'object')" :key="'stsb-' + k">
                    <div style="font-size:9px;font-weight:bold;">{{ key }}</div>
                    <div>{{ r.crm[key] }}</div>
                  </v-flex>
                  <v-flex xs12 pa-0 v-if="r.show" style="background-color: #d6d6d6;" ma-1 pa-2>
                    {{ r.crm }}
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="r.show = !r.show" color="primary">show data</v-btn>
              <v-btn @click="r.show = !r.show" color="secondary">check ninja lead</v-btn>
              <v-btn @click="getLead(r)" color="success">check crm lead</v-btn>
              <v-btn @click="archive(r)" color="error">archive</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { firebase, db, auth, store } from '@/fb';
import Axios from 'axios';
import { format, render, cancel, register } from 'timeago.js';
export default {
  props: ['resourceSettings', 'resource', 'resourceKeys', 'loading'],
  data() {
    return {
      menu: {},
      selectedPrice: {},
      booleans:["is_proccessed", "is_sync_ninja", "is_sync_crm"],
      data_json: ["data", "lead", "crm"],
      hidden: ["crm", "show"]
    }
  },
  methods: {
    async archive(r){
      this.$emit('archive', r)
    },
    async getLead(r) {
      let lead = await store.collection('leads').doc(r.lead.key).get().then(x => x.data())
      console.log(lead)
      r.crm = lead
      r.show = true
      return true
    },
    addToShortlist(id) {
      this.$emit('addToShortlist', id, this.selectedShortList)
      this.selectedShortList = null
    },
    edit(r) {
      this.$emit('editResource', r)
    },
    getFormat(d) {
      return format(d)
    },
    clipboardSuccessHandler({ value, event }) {
      this.$emit('copyS', { value, event })
    },
    clipboardErrorHandler({ value, event }) {
      this.$emit('copyF', { value, event })
    },
    openURL(url) {
      window.open(url, '_blank').blur();
      window.focus()
    }
  },
  computed: {
    i18n() {
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic() {
      if (this.$store.state.language == 'ar') return true
    },

  }
}
</script>

<style>
.noselect {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Old versions of Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
</style>